var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div", attrs: { id: "ms_header_downside" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { id: "signup" } },
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [_vm._v("新規会員登録")]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "signup_form" }, [
                    _c("label", [_vm._v("ご登録メールアドレス")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.mailAddress,
                          expression: "mailAddress",
                          modifiers: { trim: true }
                        }
                      ],
                      attrs: {
                        type: "text",
                        placeholder: "メールアドレスを入力してください。"
                      },
                      domProps: { value: _vm.mailAddress },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.mailAddress = $event.target.value.trim()
                        },
                        blur: function($event) {
                          _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "detail_btn btn_pos_left",
                        on: {
                          click: function($event) {
                            _vm.sendMail()
                          }
                        }
                      },
                      [_vm._v("仮登録する")]
                    ),
                    _vm._v(" "),
                    _vm.errors.email
                      ? _c("div", { staticClass: "error_text" }, [
                          _vm._v(_vm._s(_vm.errors.email))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "error_text" }, [
                      _vm._v(_vm._s(_vm.errorMessage.text))
                    ]),
                    _vm._v(" "),
                    _vm._m(1)
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n            以下フォームに、お客様のメールアドレスを入力し仮登録を行ってください。"
      ),
      _c("br"),
      _vm._v(
        "\n            本会員登録手続きのご案内メールをお送りいたしますので、メール内にURLより本登録をお願いします。\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n              ※ 受信制限をされている方は、「@domans.co.jp」からのメールを受信許可に設定してください。"
      ),
      _c("br"),
      _vm._v(
        "\n              ※ メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。\n            "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69a55df6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69a55df6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcSignUp.vue
// module id = null
// module chunks = 